import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Box,
	Drawer,
	InputLabel,
	Button,
	TextField,
	InputAdornment
	// Divider,
	// Typography
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SearchIcon from '@material-ui/icons/Search';
import { UserPortalContext } from 'context/appcontext';
import shareReportStyles from './ShareReport.styles';
import ShareReport from './ShareReport';
import {
	setUsersWithReportAccessSuccess,
	removeReportAccess,
	resetUsersWithReportAccess
} from '../Dashboard/Dashboard.actions';
import {
	SHARE_REPORT_TITLE,
	SHARE_SEARCH_PLACEHOLDER,
	SHARED_WITH,
	SAVE_CHANGES,
	CANCEL,
	DISCARD,
	DISCARD_WARNING,
	SHARING_SETTINGS_SAVED
} from 'constants/constant';
import PropTypes from 'prop-types';
import SharedWithList from './SharedWithList';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import DialogBox from '../Shared/DialogBox';
import RBSnackbar from 'components/Shared/RBSnackbar';

const RemoveAccess = (props) => {
	const { show, setShow, data } = props;
	const reportId = data?.reportId;

	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { firstName, lastName, email, companyName } = userDetails?.result;
	const classes = shareReportStyles();
	const dispatch = useDispatch();

	const invitedUserList = useSelector((state) => state.dashboardReducer.invitedUsers);
	const usersToRemoveAccess = useSelector((state) => state.dashboardReducer.usersToRemoveAccess);
	const usersWithReportAccess = useSelector(
		(state) => state.dashboardReducer.usersWithReportAccess
	);

	const [open, setOpen] = useState(false);
	const [shareReportShow, setShareReportShow] = useState(false);
	const [users, setUsers] = useState([]);
	const [disable, setDisable] = useState(true);
	const [showDiscardMsg, setShowDiscardMsg] = useState(false);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });

	const toggleDrawer = () => {
		if (usersToRemoveAccess.length > 0 || invitedUserList.length > 0) {
			setShowDiscardMsg(true);
		} else {
			onClose();
		}
	};

	const onClose = () => {
		setShow(false);
		setOpen(false);
		setShareReportShow(false);
		setShowDiscardMsg(false);
		dispatch(resetUsersWithReportAccess());
	};

	const handleSearchClick = () => {
		setShow(false);
		setOpen(false);
		setShareReportShow(true);
	};

	const handleBack = () => {
		setShareReportShow(false);
		setShow(true);
		setOpen(false);
	};

	const getUserList = (usersList) => {
		setUsers([]);
		const owner = { firstName: firstName, lastName: lastName, access: 'Owner', email: email };
		const withOwner = [];
		withOwner.push(owner);
		usersList?.map((user) => withOwner.push(user));
		setUsers(withOwner);
	};

	const handleSave = () => {
		dispatch(
			removeReportAccess({
				reportId,
				email,
				companyName,
				requestBody: { unShareList: usersToRemoveAccess }
			})
		);
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.REMOVE_ACCESS_BUTTON,
			location: PAGE_ID.DASHBOARD
		});
		setSnackbar({ open: true, msg: SHARING_SETTINGS_SAVED, type: 'success' });
		onClose();
	};

	useEffect(() => {
		if (show && data) {
			dispatch(setUsersWithReportAccessSuccess(data.sharedWith));
		}
	}, [show]);

	useEffect(() => {
		getUserList(usersWithReportAccess);
	}, [usersWithReportAccess]);

	useEffect(() => {
		if (usersToRemoveAccess?.length > 0) {
			setDisable(false);
		} else {
			setDisable(true);
		}
	}, [usersToRemoveAccess]);

	const cbOnShareDialogOkay = () => {
		onClose();
	};

	const cbOnShareDialogCancel = () => {
		setShowDiscardMsg(false);
	};

	const ShowShareReportDialog = () => {
		const dialogProps = {
			title: '',
			bodyContent: DISCARD_WARNING,
			secondaryBtnText: DISCARD,
			primaryBtnText: CANCEL,
			onSecondaryClick: cbOnShareDialogOkay,
			onPrimaryClick: cbOnShareDialogCancel
		};

		dialogProps.hideTitle = true;

		return <DialogBox open={showDiscardMsg} {...dialogProps} />;
	};

	return (
		<>
			<Box>
				<Drawer
					variant="temporary"
					anchor="right"
					open={show}
					id={'share-report-drawer'}
					onClose={toggleDrawer}>
					<Box className={classes.drawerContainer}>
						<Box className={classes.drawerContent}>
							<Box id="share-report" className={classes.drawer}>
								<Box id="share-report" className={classes.smallScreen}>
									<InputLabel className={classes.drawerTitle}>{SHARE_REPORT_TITLE}</InputLabel>
								</Box>
							</Box>
						</Box>
						<Box className={classes.drawerContent}>
							<Box id="search-user-list" onClick={handleSearchClick}>
								<Autocomplete
									id="user-list-search"
									readOnly
									className={classes.autoComplete}
									options={[]}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Search"
											placeholder={SHARE_SEARCH_PLACEHOLDER}
											variant="outlined"
											InputProps={{
												...params.InputProps,
												startAdornment: (
													<InputAdornment position="start">
														<SearchIcon />
													</InputAdornment>
												)
											}}
										/>
									)}
								/>
							</Box>
						</Box>
						<Box id="shared-with" className={classes.deleteReport}>
							{SHARED_WITH}
						</Box>
						<Box className={classes.drawerContent}>
							<SharedWithList
								userList={users}
								open={open}
								setOpen={setOpen}
								data={data}
								isRemovable={false}
								hasModifyAccessMenu={true}
							/>
						</Box>
					</Box>
					<Box className={classes.buttonContainer}>
						<Box>
							<Button
								id="remove-access-save-btn"
								disabled={disable}
								color="primary"
								className={`${classes.downloadButton} ${classes.drawerButton}`}
								onClick={handleSave}>
								{SAVE_CHANGES}
							</Button>
						</Box>
						<Box>
							<Button
								id="remove-access-cancel-btn"
								variant="outlined"
								color="primary"
								className={`${classes.drawerButton}`}
								onClick={toggleDrawer}>
								{CANCEL}
							</Button>
						</Box>
					</Box>
				</Drawer>
			</Box>
			<ShareReport
				show={shareReportShow}
				setShow={setShareReportShow}
				data={data}
				handleBack={handleBack}
				syncWithBE={true}
			/>
			<ShowShareReportDialog />
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				type={openSnackbar.type}
				doClose={() => {
					setSnackbar({ open: false, msg: '' });
				}}
			/>
		</>
	);
};

RemoveAccess.propTypes = {
	setShow: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired
};

export default RemoveAccess;
